import React, { useContext } from "react";
import { useState, useEffect } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./ViewOffCanvance.css";
import { Context } from "../../utils/context";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import "react-phone-input-2/lib/bootstrap.css";
import Select from "react-select";
import { CancelButton, SaveButton } from "../common/Button";
import ModalSave from "../common/ModelSave";

library.add(fas);

const ViewOffCanvance = (props) => {
  const [value, setValue] = React.useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const dataToSend = new FormData();
      dataToSend.append("stage", data?.stage?.value);
      dataToSend.append("email", data?.email);
      const response = await postData(
        `/employee/seller/request/${props.id}`,
        dataToSend
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [data, setData] = useState();

  const getSellerData = async () => {
    const res = await getData(`/finance-product-report/${props.id}`);
    setData(res.data?.data);
  };

  useEffect(() => {
    getSellerData();
  }, [props.id]);

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%", height: "auto" }}
        placement={"end"}
        onHide={props.handleClose}
        className="offcan"
      >
        <Container className="tabss-main">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5 bg-white rounded">
              <Card.Body>
                <Card.Title>
                  <h3>Product Details </h3>
                </Card.Title>

                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="About Product" value="1" />
                        <Tab label="Seller Details" value="2" />
                        <Tab label="Product Details" value="3" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div>
                        <div>
                          <h3>About Product</h3>
                        </div>

                        <div>
                          <Row>
                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Product Id</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.id}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Product Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Short Description</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.short_description}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Membership</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.membership_type
                                            ? data?.membership_type
                                            : "No Membership"
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Membership Discount </Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.membership_discount
                                            ? data?.membership_discount
                                            : "No Membership Discount"
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>COD Available </Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.cod_available ? "YES" : "NO"
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Category</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.category?.name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Commission</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.commission}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div>
                        <div>
                          <h3>Seller Details</h3>
                        </div>

                        <div>
                          <Row>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>First Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.user?.first_name}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Last Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.user?.last_name || "-"}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>{" "}
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Email</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.user?.email}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>{" "}
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Contact Number</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={data?.user?.contact_no}
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Service Start Date</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.user?.commission_s_date
                                            ? new Date(
                                                data.user.commission_s_date
                                              ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                              })
                                            : ""
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col md={4}>
                              <div className="main-form-section mt-4">
                                <Row className="justify-content-center">
                                  <Form.Label>Service End Date</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        value={
                                          data?.user?.commission_e_date
                                            ? new Date(
                                                data.user.commission_e_date
                                              ).toLocaleDateString("en-GB", {
                                                day: "numeric",
                                                month: "short",
                                                year: "numeric",
                                              })
                                            : ""
                                        }
                                        disabled
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="3">
                      <div>
                        {data?.type == "Single" ? (
                          <div>
                            <div>
                              <h4>Single Varient</h4>
                            </div>
                            <Row>
                              {/* <Col lg={4}> */}

                              <div className="main-form-section mt-4">
                                {data?.product_variants.map((value) => {
                                  return (
                                    <>
                                      <Row className="justify-content-center">
                                        <Col lg={4}>
                                          <Form.Label>
                                            Single Variant
                                          </Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.v_name}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>Unit</Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.unit}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>SKU</Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.sku}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>MRP</Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.mrp}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>Selling Price</Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.s_price}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>Trade Percent</Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.trade}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>
                                            Scheme Percent
                                          </Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.scheme}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>
                                            Extra Discount In Rupees
                                          </Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.scheme}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          <Form.Label>
                                            Weight Or Piece
                                          </Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.weight_or_piece}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>

                                        <Col lg={4}>
                                          {value?.weight_or_piece == "piece" ? (
                                            <Row className="justify-content-center">
                                              <Form.Label> Piece</Form.Label>
                                              <Form.Group>
                                                <InputGroup>
                                                  <Form.Control
                                                    type="text"
                                                    value={value?.piece}
                                                    disabled
                                                  />
                                                </InputGroup>
                                              </Form.Group>
                                            </Row>
                                          ) : (
                                            <Row className="justify-content-center">
                                              <Form.Label>Weight</Form.Label>
                                              <Form.Group>
                                                <InputGroup>
                                                  <Form.Control
                                                    type="text"
                                                    value={value?.weight}
                                                    disabled
                                                  />
                                                </InputGroup>
                                              </Form.Group>
                                            </Row>
                                          )}
                                        </Col>

                                        <Col lg={4}>
                                          <Row className="justify-content-center">
                                            <Form.Label>
                                              Cost To boomerbucks
                                            </Form.Label>
                                            <Form.Group>
                                              <InputGroup>
                                                <Form.Control
                                                  type="text"
                                                  value={
                                                    value?.cost_to_boomerbucks
                                                  }
                                                  disabled
                                                />
                                              </InputGroup>
                                            </Form.Group>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </>
                                  );
                                })}
                              </div>

                              {/* </Col> */}
                            </Row>
                          </div>
                        ) : (
                          <div>
                            {" "}
                            <div>
                              <h4>Multiple Varient</h4>
                            </div>
                            <Row>
                              {data?.product_multiple_mains.map((value) => {
                                return (
                                  <Col lg={12} key={value?.id}>
                                    <div className="main-form-section mt-4">
                                      <Row className="justify-content-center">
                                        <Col lg={4}>
                                          <Form.Label>
                                            Multiple Main Variant
                                          </Form.Label>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                value={value?.varient_name}
                                                disabled
                                              />
                                            </InputGroup>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>

                                    {value?.product_multiple_variants?.map(
                                      (value2) => {
                                        return (
                                          <>
                                            {/* <Col lg={4} key={value2?.id}> */}
                                            <div className="main-form-section mt-4">
                                              <Row className="justify-content-center">
                                                <Col lg={4}>
                                                  <Form.Label>
                                                    Variant Sub Name
                                                  </Form.Label>
                                                  <Form.Group>
                                                    <InputGroup>
                                                      <Form.Control
                                                        type="text"
                                                        value={
                                                          value2?.varient_sub_name
                                                        }
                                                        disabled
                                                      />
                                                    </InputGroup>
                                                  </Form.Group>
                                                </Col>
                                                <Col lg={4}>
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Unit
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.unit}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <Col lg={4}>
                                                  <Row className="justify-content-center">
                                                    <Form.Label>SKU</Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.sku}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <Col lg={4}>
                                                  <Row className="justify-content-center">
                                                    <Form.Label>MRP</Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.mrp}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Selling Price
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={
                                                            value2?.s_price
                                                          }
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Trade Percent
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.trade}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>{" "}
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Scheme Percent
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.scheme}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Discount In Rupees
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={value2?.scheme}
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>{" "}
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Weight Or Piece
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={
                                                            value2?.weight_or_piece
                                                          }
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                {value2?.weight_or_piece ==
                                                "piece" ? (
                                                  <Col lg={4}>
                                                    {" "}
                                                    <Row className="justify-content-center">
                                                      <Form.Label>
                                                        Piece
                                                      </Form.Label>
                                                      <Form.Group>
                                                        <InputGroup>
                                                          <Form.Control
                                                            type="text"
                                                            value={
                                                              value2?.piece
                                                            }
                                                            disabled
                                                          />
                                                        </InputGroup>
                                                      </Form.Group>
                                                    </Row>
                                                  </Col>
                                                ) : (
                                                  <Col lg={4}>
                                                    {" "}
                                                    <Row className="justify-content-center">
                                                      <Form.Label>
                                                        Weight
                                                      </Form.Label>
                                                      <Form.Group>
                                                        <InputGroup>
                                                          <Form.Control
                                                            type="text"
                                                            value={
                                                              value2?.weight
                                                            }
                                                            disabled
                                                          />
                                                        </InputGroup>
                                                      </Form.Group>
                                                    </Row>
                                                  </Col>
                                                )}
                                                <Col lg={4}>
                                                  {" "}
                                                  <Row className="justify-content-center">
                                                    <Form.Label>
                                                      Cost To Boomerbucks
                                                    </Form.Label>
                                                    <Form.Group>
                                                      <InputGroup>
                                                        <Form.Control
                                                          type="text"
                                                          value={
                                                            value2?.cost_to_boomerbucks
                                                          }
                                                          disabled
                                                        />
                                                      </InputGroup>
                                                    </Form.Group>
                                                  </Row>
                                                </Col>
                                                <hr></hr>
                                              </Row>
                                            </div>
                                          </>
                                        );
                                      }
                                    )}
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        )}
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
          {/* <Col md={4}>
            <div className="main-form-section mt-3">
              <Form.Group>
                <Form.Label>Take an action</Form.Label>
                <InputGroup>
                  <Controller
                    name="stage" // name of the field
                    control={control}
                    rules={{ required: "Take an Action" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.stage ? "red" : baseStyles.borderColor,
                          }),
                        }}
                        options={[
                          { value: "Approved", name: "option", label: "Approve" },
                          { value: "Rejected", name: "option", label: "Reject" },
                        ]}
                      />
                    )}
                  />
                </InputGroup>
                {errors.stage && <p style={{ color: "red" }}>{errors.stage.message}</p>}
              </Form.Group>
            </div>
          </Col>

          <Row className="mt-5 pb-3">
            <div className="d-flex justify-content-center">

              <CancelButton
                name={"Back"}
                handleClose={props.handleClose}
              />


              <SaveButton
                name={"save"}
                handleSubmit={handleSubmit(onSubmit)}
              />
            </div>
          </Row> */}
        </Container>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default ViewOffCanvance;
